import * as Yup from 'yup';

export const loginAuthenticationSchema = Yup.object().shape({
  confirmationcode: Yup.string()
    .required('Confirmation code is required'),
});